import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/app/Layout";
import Login from "@/pages/Login";
import Disbursements from "@/pages/Disbursements";
import AllList from "@/pages/AllList";
import OwnBrandSales from "@/pages/OwnBrandSales";
import Expenses from "@/pages/Expenses";
import HR from "@/pages/HRDocuments";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import AddIncome from "@/pages/AddIncome";
import SignPage from "@/pages/public/SignPage";
import VerifyPage from "@/pages/public/VerifyPage";
import DevelopmentForm from "@/pages/public/DevelopmentForm";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-zinc-50">
        <div className="h-8 w-8 border-2 border-zinc-200 border-t-zinc-900 rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function Landing() {
  const { user, loading, can, isAdmin } = useAuth();
  if (loading) return null;
  if (!user) return <Login />;
  if (isAdmin() || can("reports.view")) return <Navigate to="/reports" replace />;
  if (can("loan.view")) return <Navigate to="/disbursements" replace />;
  if (can("sales.view")) return <Navigate to="/ob-sales" replace />;
  return <Navigate to="/disbursements" replace />;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reports" element={<Protected><Reports /></Protected>} />
      <Route path="/add-income" element={<Protected><AddIncome /></Protected>} />
      <Route path="/disbursements" element={<Protected><Disbursements /></Protected>} />
      <Route path="/all-list" element={<Protected><AllList /></Protected>} />
      <Route path="/ob-sales" element={<Protected><OwnBrandSales /></Protected>} />
      <Route path="/expenses" element={<Protected><Expenses /></Protected>} />
      <Route path="/hr" element={<Protected><HR /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/sign/:token" element={<SignPage />} />
      <Route path="/verify/:id" element={<VerifyPage />} />
      <Route path="/development-form" element={<DevelopmentForm />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
